
<template>
  <div class="part5">
    <div class="partBox">
      <div class="now_person_box">
        <i>{{ nowperson }}</i>
        <p
          class="iostore yybtn"
          v-if="ios == 'ios'"
          @click="googleShop(pageInfo.appleStoreUrl)"
        ></p>
        <p
          class="googleStore yybtn"
          v-else
          @click="googleShop(pageInfo.googleStoreUrl)"
        ></p>
        <div class="handz"></div>
      </div>
      <div class="dcb dl">
        <div
          class="dcb_item pr"
          v-for="(item, index) in giftList"
          :key="'item' + index"
          :class="'dcb_item' + index"
          :data-value="item.value"
          @click="peopleClisk(index)"
        >
          <div style="width: 100%; height: 100%; position: relative">
            <div
              class="dcbItem"
              style="width: 100%; height: 100%"
              :class="item.show ? 'showActive' : 'hideActive'"
            ></div>
            <p class="dcb_person pa">
              <img
                src="../assets/images/page5/reach.png"
                alt=""
                :class="{ status: !item.status }"
              />
            </p>
          </div>
          <div class="handz" v-if="index == 3"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { shopSubscribe } from "@/js/api.js";
export default {
  name: "pageFive",
  props: ["pageInfo", "allCode"],
  data() {
    return {
      nowperson: "",
      giftList: [
        {
          value: 500000,
          text: "50W人",
          show: false,
        },
        {
          value: 400000,
          text: "40W人",
          show: false,
        },
        {
          value: 300000,
          text: "30W人",
          show: false,
        },
        {
          value: 100000,
          text: "10W人",
          show: false,
        },
        {
          value: 200000,
          text: "20W人",
          show: false,
        },
      ],
      ios: "", //设备系统判断
      backNum: this.$util.getItem("backShowNum") || 0,
    };
  },
  created() {
    this.ios = this.$util.appSource();
  },
  mounted() {
    this.$nextTick(() => {
      this.$on("pagefive", (res) => {
        this.nowperson = res;
        this.compare();
      });
    });
    this.$bus.$on("point4", () => {
      this.anchor();
    });
    this.$bus.$on("num2", (res) => {
      this.backNum = res;
    });
  },
  methods: {
    peopleClisk(index) {
      console.log(index);
      let item = document.getElementsByClassName("dcbItem");
      if (index == 0) {
        item[0].id = "dcb_item0_n";
      } else if (index == 1) {
        item[1].id = "dcb_item1_n";
      } else if (index == 2) {
        item[2].id = "dcb_item2_n";
      } else if (index == 3) {
        item[3].id = "dcb_item3_n";
      } else {
        item[4].id = "dcb_item4_n";
      }
      this.giftList[index].show = !this.giftList[index].show;
    },
    googleShop(value) {
      let phoneData = this.$util.getToken();
      if (phoneData) {
        let data = this.$util.getToken().token;
        shopSubscribe(data).then(() => {
          // console.log(res);
          this.$xmlog.clickStore(() => {
            location.href = value;
            this.$util.setItem("backShow", true);
            this.$util.setItem("backShowNum", this.backNum + 1);
            this.$bus.$emit("num", this.backNum + 1);
          });
        });
      } else {
        // this.$bus.$emit("tips", "請先預約");
        this.$xmlog.clickStore(() => {
          location.href = value;
          this.$util.setItem("backShow", true);
          this.$util.setItem("backShowNum", this.backNum + 1);
          this.$bus.$emit("num", this.backNum + 1);
        });
        // location.href = value;
      }
    },
    //定位
    anchor() {
      let ele = document.getElementsByClassName("part5")[0];
      // ele.scrollIntoView({ behavior: "smooth", block: 'nearest', inline: 'nearest' });
      let eletop = ele.offsetTop;
      window.scrollTo({
        top: eletop,
        behavior: "smooth",
      });
    },
    reach() {
      this.nowperson = this.pageInfo.people;
      this.compare();
    },
    compare() {
      this.giftList.forEach((itme, index) => {
        if (this.nowperson >= itme.value) {
          this.$set(this.giftList[index], "status", true);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.part5 {
  width: 100%;
  .partBox {
    .now_person_box {
      background: url("../assets/images/page5/personBox.png") no-repeat;
      background-size: 100% 100%;
      position: relative;
      top: 0.5rem;
      width: 4.2rem;
      height: 4.1rem;
      margin-left: 0.2rem;
      margin-top: 2.1rem;

      i {
        font-weight: 800;
        color: #214d73;
        font-family: Source Han Serif CN;
        font-size: 0.3rem;
        position: absolute;
        right: 0rem;
        top: 1.8rem;
        width: 2rem;
        text-align: left;
      }

      .googleStore {
        background: url("../assets/images/page5/ggyy.png") no-repeat;
      }

      .iostore {
        background: url("../assets/images/page5/iosyy.png") no-repeat;
      }

      .yybtn {
        position: absolute;
        bottom: -0.2rem;
        left: 50%;
        transform: translateX(-50%) scale(1.4);
        width: 1.7rem;
        height: 0.84rem;
        background-size: contain;
        background-position: center;
        cursor: pointer;
      }

      .handz {
        position: absolute;
        bottom: -0.4rem;
        right: 16%;
        background: url("../assets/images/page2/ckHand.png");
        background-size: contain;
        height: 0.7rem;
        width: 0.7rem;
        cursor: pointer;
        animation: scale 1.5s infinite;
      }
    }

    .dcb {
      width: 100%;
      height: 7rem;
      text-align: center;
      margin-top: 2rem;
      flex-wrap: wrap;
      position: relative;
      opacity: 1;

      .dcb_item {
        // width: 26%;
        // height: 3rem;
        position: absolute;
        cursor: pointer;

        // background-size: 100%;
        // background-position: top;
        .dcb_person {
          height: 1.3rem;
          bottom: -0.1rem;
          left: 50%;
          transform: translateX(-50%);

          img {
            height: 100%;
          }

          .status {
            filter: grayscale(100%);
          }
        }
        .handz {
          position: absolute;
          bottom: -44%;
          right: 13%;
          background: url("../assets/images/page2/ckHand.png");
          background-size: contain;
          height: 0.7rem;
          width: 0.7rem;
          cursor: pointer;
          animation: scale 1.5s infinite;
        }
      }
      .showActive {
        opacity: 1;
        transition: all 1s ease-out;
        transform: rotateY(0deg);
        image-rendering: -moz-crisp-edges;
        image-rendering: -o-crisp-edges;
        image-rendering: -webkit-optimize-contrast;
        image-rendering: crisp-edges;
        -ms-interpolation-mode: nearest-neighbor;
      }
      .hideActive {
        opacity: 0;
        transition: all 1s ease-out;
        transform: rotateY(180deg);
      }

      #dcb_item0_n {
        background: url("../assets/images/page5/150.png") no-repeat;
        background-size: 100% 100%;
      }

      #dcb_item1_n {
        background: url("../assets/images/page5/100.png") no-repeat;
        background-size: 100% 100%;
      }

      #dcb_item2_n {
        background: url("../assets/images/page5/50.png") no-repeat;
        background-size: 100% 100%;
      }

      #dcb_item3_n {
        background: url("../assets/images/page5/10.png") no-repeat;
        background-size: 100% 100%;
      }

      #dcb_item4_n {
        background: url("../assets/images/page5/30.png") no-repeat;
        background-size: 100% 100%;
      }

      .dcb_item0 {
        top: 2%;
        left: 0.4rem;
        width: 2.1rem;
        height: 2.6rem;
        .dcb_person {
          height: 1.5rem;
          bottom: -1rem;
        }
      }

      .dcb_item1 {
        top: 11%;
        left: 45.5%;
        width: 1.72rem;
        height: 2.05rem;
        .dcb_person {
          height: 1.1rem;
          width: 1.1rem;
          bottom: -0.9rem;
        }
      }

      .dcb_item2 {
        top: 33%;
        right: 4%;
        width: 1.67rem;
        height: 2.03rem;
        .dcb_person {
          height: 1.1rem;
          width: 1.1rem;
          bottom: -0.9rem;
        }
      }

      .dcb_item3 {
        top: 60%;
        left: 6%;
        width: 1.78rem;
        height: 2.21rem;
        .dcb_person {
          height: 1.1rem;
          width: 1.1rem;
          bottom: -0.6rem;
        }
      }

      .dcb_item4 {
        top: 53%;
        left: 41.5%;
        width: 1.66rem;
        height: 2.05rem;
        .dcb_person {
          height: 1.1rem;
          width: 1.1rem;
          bottom: -0.8rem;
        }
      }

      .per {
        font-size: 0.3rem;
        height: 100%;
      }
    }
  }
}
@keyframes rotateY {
  0% {
    transform: rotateY("0");
  }
  100% {
    transform: rotateY("90");
  }
}
@keyframes scale {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
</style>